import qs from 'qs';
import { LOCATION_CHANGE } from 'connected-react-router';
import { takeEvery } from 'redux-saga/effects';
import { matchPath } from 'react-router';
import { ROUTES } from 'src/constants';
import toast from 'src/components/Toast';

const authRoutes = [ROUTES.signIn, ROUTES.signUpCandidate, ROUTES.signUpEmployer];

function locationChangeWorker({ payload }) {
  const { pathname, search } = payload.location;

  const isAuthRoute = authRoutes.find(
    route =>
      !!matchPath(pathname, {
        path: route,
        exact: true,
        strict: false
      })
  );

  if (isAuthRoute) {
    const { error } = qs.parse(search, { ignoreQueryPrefix: true });
    if (error) {
      const formattedError = String(error).replace(/\+/g, ' ');
      toast.error(formattedError);
    }
  }
}

export default function* locationChangeWatcher() {
  yield takeEvery(LOCATION_CHANGE, locationChangeWorker);
}
